import { z } from 'zod';

const EnvSchema = z.object({
  VITE_PORTAL_API_URL: z
    .string()
    .url('VITE_PORTAL_API_URL must be a full URL (e.g. http://localhost:8080)')
    .default('http://localhost:8080')
    .transform((s) => s.replace(/\/+$/, '')),
});

const parsed = EnvSchema.safeParse(import.meta.env);
if (!parsed.success) {
  const issues = parsed.error.issues.map((i) => `  - ${i.path.join('.')}: ${i.message}`).join('\n');
  throw new Error(`Invalid frontend env:\n${issues}\n\nCheck your .env / .env.local — see .env.example.`);
}

export const env = parsed.data;
export type AppEnv = z.infer<typeof EnvSchema>;
